
  export const GetAllMasterCategotryGroup = async (dataJson: any) => {
    
    const respone = await fetch("api/Ecatalog/GetAllMasterCategotryGroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };


  export const SearchCatalogItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/SearchCatalogItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetWolfTemplate = async (documentCode: string) => 
  {
    const respone = await fetch("api/Ecatalog/GetWolfTemplate?documentCode=" + documentCode )
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    return respone;//.filter((e: any) => e.IsActive === true);
  };
  
  export const CreateMemorandum = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/CreateMemorandum", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const InsertTransactionOrderitem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/InsertTransactionOrderitem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetSellerById = async (sellerID: number) => 
  {
    const respone = await fetch("api/Supplier/GetSellerById?SellerID=" + sellerID)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    return respone;//.filter((e: any) => e.IsActive === true);
  };
  
  export const InsertFavoriteItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/InsertFavoriteItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
   
  export const DeleteFavoriteItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/DeleteFavoriteItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const ReceiveAddress = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/ReceiveAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetBudget = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetECatalogBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const SetBudget = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/SetBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetBudgetByEmpCode = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetBudgetByEmpCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const GetECatalogCostcenter = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetECatalogCostcenter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const GetCostcenterBudgetByCode = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetCostcenterBudgetByCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };


  
  
  